export default "__VITE_ASSET__JS9jczi4__"